
import { defineComponent } from "vue";

import { CBtn } from "../../vuetify-components";

export default defineComponent({
  components: { CBtn },
  mixins: [CBtn],
  props: {
    isFollowing: {
      type: [Boolean, String],
      default: false,
    },
  },
});
